export default __webpack_public_path__ + "static/media/12.d8683cd4.jpg";